import { render, staticRenderFns } from "./Suivi_VH.vue?vue&type=template&id=483e8334"
import script from "./Suivi_VH.vue?vue&type=script&lang=js"
export * from "./Suivi_VH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports